import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
  },
  correctAnswerMessage: {
    alignSelf: "flex-start",
    marginLeft: 20,
    color: "$correct",
    fontSize: "$option_text_size",
  },
  correctAnswer: {
    fontWeight: "bold",
  },
  previews: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
  },
});
